// @flow
import { defineMessages } from 'react-intl';

const messages = defineMessages({
    eventTime: {
        defaultMessage: '{time, date, medium}',
        description: 'The time that an event occurred',
        id: 'boxui.readableTime.eventTime',
    },
    eventTimeToday: {
        defaultMessage: 'Today at {time, time, short}',
        description: 'The time that an event occurred today',
        id: 'boxui.readableTime.eventTimeToday',
    },
    eventTimeYesterday: {
        defaultMessage: 'Yesterday at {time, time, short}',
        description: 'The time that an event occurred yesterday',
        id: 'boxui.readableTime.eventTimeYesterday',
    },
    eventTimeDate: {
        defaultMessage: '{time, date, medium} at {time, time, short}',
        description: 'The time that an event occurred at a given date with the year included',
        id: 'boxui.readableTime.eventTimeDate',
    },
    eventTimeDateShort: {
        defaultMessage: '{date} at {time, time, short}',
        description: 'The time that an event occurred at a given date without the year included',
        id: 'boxui.readableTime.eventTimeDateShort',
    },
    eventTimeWeekdayLong: {
        defaultMessage: '{weekday}, {time, date, medium}',
        description: 'The time that an event occurred at a given date with the weekday included',
        id: 'boxui.readableTime.eventTimeWeekdayLong',
    },
});

export default messages;
